import type { ModuleMigrationDef } from "@kubdee/sdk";

/**
 * Wire Facebook Messenger up for Facebook Login for Business (FLB) AND bump
 * Graph API v19.0 → v25.0.
 *
 * Two independent fixes, bundled because they touch the same JSON blob:
 *
 * 1. **FLB opt-in** — adds `configIdEnv: "FACEBOOK_MESSENGER_CONFIG_ID"`.
 *    When that secret is set, `/oauth/start` sends Meta a server-side
 *    `config_id` instead of a scope list. Meta's asset picker then returns
 *    Pages the user reaches via a Business Portfolio (the "Kubdee
 *    AutoGen"-style pages the classic `pages_show_list` flow silently
 *    dropped). Secret unset → classic scope flow unchanged.
 *
 * 2. **Graph API version bump** — v19.0 expires 2026-05-21. Every authorize
 *    URL + token exchange URL currently embedded in the row is rewritten to
 *    v25.0 (stable since 2026-02).
 *
 * Idempotent via `json_set` + version-aware WHERE: re-running the migration
 * is a no-op; `updated_at` only bumps when at least one field actually
 * changed.
 */
export const migration: ModuleMigrationDef = {
  key: "010_facebook_messenger_flb",
  version: "0.10.0",
  sql: `
UPDATE \`connectors_types\`
  SET \`oauth_config\` = json_set(
        json_set(
          json_set(
            \`oauth_config\`,
            '$.configIdEnv',
            'FACEBOOK_MESSENGER_CONFIG_ID'
          ),
          '$.authorizeUrl',
          'https://www.facebook.com/v25.0/dialog/oauth'
        ),
        '$.tokenUrl',
        'https://graph.facebook.com/v25.0/oauth/access_token'
      ),
      \`updated_at\` = '2026-04-19T00:00:00Z'
  WHERE \`id\` = 'facebook-messenger'
    AND (
      json_extract(\`oauth_config\`, '$.configIdEnv') IS NULL
      OR json_extract(\`oauth_config\`, '$.authorizeUrl')
         != 'https://www.facebook.com/v25.0/dialog/oauth'
      OR json_extract(\`oauth_config\`, '$.tokenUrl')
         != 'https://graph.facebook.com/v25.0/oauth/access_token'
    );
  `.trim(),
};
